export default __webpack_public_path__ + "img/976f4ca42e01510d7da1f65e16de468e.svg";